import { Input } from '@mantine/core';
import type { ReactNode } from 'react';
import { defaultCountries, PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

const countries: typeof defaultCountries = [
  ...defaultCountries.filter((country) => country[1] === 'hn'),
  ...defaultCountries.filter((country) => country[1] === 'us'),
  ...defaultCountries.filter((country) => country[1] !== 'hn' && country[1] !== 'us'),
];

export interface PhoneFieldProps {
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  error?: ReactNode;
  required?: boolean;
  disabled?: boolean;
  name?: string;
}

/**
 * One country-aware phone control for customers, staff, partners and vendors.
 *
 * Honduras is both the default and the first country in the selector; the US stays immediately
 * below it for the other common case. `react-international-phone` emits E.164, so the backend sees
 * the country code rather than a locally formatted string whose country has been lost.
 */
export function PhoneField({
  label,
  description,
  value,
  onChange,
  error,
  required,
  disabled,
  name,
}: PhoneFieldProps) {
  return (
    <Input.Wrapper label={label} description={description} error={error} required={required}>
      <PhoneInput
        defaultCountry="hn"
        preferredCountries={['hn', 'us']}
        countries={countries}
        value={value}
        onChange={onChange}
        disabled={disabled}
        name={name}
        forceDialCode
        inputProps={{ 'aria-label': label }}
        style={{ width: '100%' }}
        inputStyle={{
          width: '100%',
          height: 'var(--input-height-sm)',
          background: 'var(--mantine-color-body)',
          color: 'var(--mantine-color-text)',
          borderColor: error ? 'var(--mantine-color-error)' : 'var(--input-bd)',
          fontSize: 'var(--mantine-font-size-sm)',
        }}
        countrySelectorStyleProps={{
          buttonStyle: {
            height: 'var(--input-height-sm)',
            background: 'var(--mantine-color-body)',
            borderColor: error ? 'var(--mantine-color-error)' : 'var(--input-bd)',
          },
        }}
      />
    </Input.Wrapper>
  );
}
